const STORAGE_KEY = 'colorMap';

// Fixed label-to-color assignments
const predefinedColors = {
    Good: '#a1d6b2',     // mint green
    Damaged: '#ff8080',  // soft red
};

const initialColors = [
    '#cad4dc', '#bfecff', '#f6f193', '#ffe0ac', '#c6f7e2',
    '#e0bbff', '#ffb3ba', '#d5f4e6',
];

const colorMap = new Map(loadColorMapFromStorage());
const usedColors = new Set([...colorMap.values()]);

// Initialize predefined label colors first
for (const [label, color] of Object.entries(predefinedColors)) {
    if (!colorMap.has(label)) {
        colorMap.set(label, color);
        usedColors.add(color);
    }
}

// Skip initialColors already used (by predefined)
let colorIndex = 0;
while (colorIndex < initialColors.length && usedColors.has(initialColors[colorIndex])) {
    colorIndex++;
}

function getColor(label) {
    const key = String(label);
    if (!colorMap.has(key)) {
        const color = getNextColor();
        colorMap.set(key, color);
        usedColors.add(color);
        saveColorMapToStorage();
    }
    return colorMap.get(key);
}

function ensureColors(labels = []) {
    let updated = false;
    labels.forEach(label => {
        const key = String(label);
        if (!colorMap.has(key)) {
            const color = getNextColor();
            colorMap.set(key, color);
            usedColors.add(color);
            updated = true;
        }
    });
    if (updated) saveColorMapToStorage();
}

function getColors(labels = []) {
    return labels.map(getColor);
}

function getNextColor() {
    if (colorIndex < initialColors.length) {
        return initialColors[colorIndex++];
    }

    let color;
    let attempts = 0;
    do {
        color = generatePastelColor();
        attempts++;
    } while (usedColors.has(color) && attempts < 100);

    return color;
}

function generatePastelColor() {
    const hue = Math.floor(Math.random() * 360);
    const saturation = 70 + Math.random() * 10;
    const lightness = 80 + Math.random() * 10;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

function saveColorMapToStorage() {
    const obj = Object.fromEntries(colorMap);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
}

function loadColorMapFromStorage() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? Object.entries(JSON.parse(stored)) : [];
    } catch {
        return [];
    }
}

function reset() {
    colorMap.clear();
    usedColors.clear();
    colorIndex = 0;
    localStorage.removeItem(STORAGE_KEY);

    // Reassign predefined colors on reset
    for (const [label, color] of Object.entries(predefinedColors)) {
        colorMap.set(label, color);
        usedColors.add(color);
    }
    while (colorIndex < initialColors.length && usedColors.has(initialColors[colorIndex])) {
        colorIndex++;
    }
}

function generateColors(count) {
    const fixedColors = [
        "rgba(201, 235, 255, 0.8)",
        "rgba(255, 140, 140, 0.8)",
        "rgba(255, 246, 173, 0.8)",
        "rgba(183, 226, 197, 0.8)",
    ];

    const result = [];
    for (let i = 0; i < count; i++) {
        result.push(fixedColors[i % fixedColors.length]);
    }
    return result;
}

export const ColorUtil = {
    getColor,
    getColors,
    ensureColors,
    reset,
    generateColors,
};